import React from "react";
import { SearchBox } from "@fluentui/react";
import { useTranslation } from "react-i18next";
const Search = (props) => {
  const searchBoxStyles = { root: { width: 300 } };
  const [t, i18n] = useTranslation();

  const handleSearch = (e) => {
    props.setSearchText(e.target.value);
    props.setPageNumber(1);
  };

  return (
    <div>
      <SearchBox
        styles={searchBoxStyles}
        placeholder={t("button.search")}
        onChange={(e) => handleSearch(e)}
      />
    </div>
  );
};

export default Search;
